import styled from "styled-components";
import {Select} from "antd";

export const MySelectStyles = styled(Select)`

`